import { render } from "./Component-icons.vue?vue&type=template&id=501e62b0"
import script from "./Component-icons.vue?vue&type=script&lang=js"
export * from "./Component-icons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__